import { Patient } from '../store/types/patient';
import { GET_PROFILES_BY_MOBILE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type ProfileByMobile = Patient & { localId?: string; id: string };

export interface Root {
    success: boolean;
    profiles: ProfileByMobile[];
}

export default (mobile: string, cid?: string, enableNdhmDiscovery?: boolean): Promise<Root> =>
    fetchWithRefresh(GET_PROFILES_BY_MOBILE(encodeURIComponent(mobile), cid, enableNdhmDiscovery), {
        mode: 'cors',
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('can not fetch profiles');
        }
    });
